<script>
export default {
  data() {
    return {
      isClick: false,
      isClicked: false,
      isClickedOne: false,
      isClickedTwo: false,
      isClickedThree: false,
      isPasswordVisible: false,
      title: "Bookings",
      text: "Customer",
      text1: "Bookings",
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/customer/user-booking-list");
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    toggleClick() {
      this.isClick = !this.isClick;
    },
    toggleClicked() {
      this.isClicked = !this.isClicked;
    },
    toggleClickedOne() {
      this.isClickedOne = !this.isClickedOne;
    },
    toggleClickedTwo() {
      this.isClickedTwo = !this.isClickedTwo;
    },
    toggleClickedThree() {
      this.isClickedThree = !this.isClickedThree;
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <!-- Breadcrumb -->
  <page-breadcrumb :title="title" :text="text" :text1="text1" />
  <!-- /Breadcrumb -->
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-3 col-lg-4">
            <customer-sidebar></customer-sidebar>
          </div>
          <div class="col-xl-9 col-lg-8">
            <div
              class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4"
            >
              <h4>Booking List</h4>
              <div class="d-flex align-items-center">
                <p class="text-dark me-2 mb-0">Sort</p>
                <div class="dropdown me-2">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Newly Added
                  </a>
                  <div class="dropdown-menu">
                    <a href="javascript:void(0);" class="dropdown-item active"
                      >Newly Added</a
                    >
                    <a href="javascript:void(0);" class="dropdown-item">Oldest</a>
                  </div>
                </div>
                <router-link
                  to="/customer/user-bookings-calendar"
                  class="tags d-flex justify-content-center align-items-center border rounded me-2"
                  ><i class="ti ti-calendar-month"></i
                ></router-link>
                <a
                  href="javascript:void(0);"
                  class="tags d-flex justify-content-center align-items-center border rounded"
                  ><i class="ti ti-filter"></i
                ></a>
              </div>
            </div>
            <div class="card shadow-none booking-list">
              <div class="card-body d-md-flex align-items-center">
                <div
                  class="booking-widget d-sm-flex align-items-center row-gap-3 flex-fill mb-3 mb-md-0"
                >
                  <div class="booking-img me-sm-3 mb-3 mb-sm-0">
                    <router-link to="/booking/booking-details" class="avatar">
                      <img src="@/assets/img/services/service-08.jpg" alt="User Image" />
                    </router-link>
                    <div class="fav-item">
                      <a
                        href="javascript:void(0)"
                        class="fav-icon"
                        :class="{ selected: isClick }"
                        @click="toggleClick"
                      >
                        <i class="feather-heart"></i>
                      </a>
                    </div>
                  </div>
                  <div class="booking-det-info">
                    <h6 class="mb-3">
                      <router-link to="/booking/booking-details">Computer Services </router-link
                      ><span class="badge badge-soft-danger ms-2">Cancelled</span>
                    </h6>
                    <ul class="booking-details">
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Booking Date</span>
                        <small class="me-2">: </small>27 Sep, 17:00-18:00
                      </li>
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Amount</span>
                        <small class="me-2">: </small> $100.00<span
                          class="badge badge-soft-primary ms-2"
                          >Paypal</span
                        >
                      </li>
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Location</span>
                        <small class="me-2">: </small>Newyork, USA
                      </li>
                      <li class="d-flex align-items-center flex-wrap">
                        <span class="book-item">Provider</span>
                        <small class="me-2">: </small>
                        <div class="user-book d-flex align-items-center flex-wrap me-2">
                          <div class="avatar avatar-xs me-2">
                            <img
                              class="avatar-img rounded-circle"
                              alt="User Image"
                              src="@/assets/img/profiles/avatar-02.jpg"
                            />
                          </div>
                          John Doe
                        </div>
                        <p class="mb-0 me-2">
                          <i class="ti ti-point-filled fs-10 text-muted me-2"></i
                          >info@johndoe.com
                        </p>
                        <p>
                          <i class="ti ti-point-filled fs-10 text-muted me-2"></i>+1 888
                          888 8888
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div>
                  <router-link
                    to="/booking/booking"
                    class="btn btn-light"
                    data-bs-toggle="modal"
                    data-bs-target="#reschedule"
                    >Reschedule</router-link
                  >
                </div>
              </div>
            </div>
            <div class="card shadow-none booking-list">
              <div class="card-body d-md-flex align-items-center">
                <div
                  class="booking-widget d-sm-flex align-items-center row-gap-3 flex-fill mb-3 mb-md-0"
                >
                  <div class="booking-img me-sm-3 mb-3 mb-sm-0">
                    <router-link to="/booking/booking-details" class="avatar">
                      <img src="@/assets/img/services/service-09.jpg" alt="User Image" />
                    </router-link>
                    <div class="fav-item">
                      <a
                        href="javascript:void(0)"
                        class="fav-icon"
                        :class="{ selected: isClicked }"
                        @click="toggleClicked"
                      >
                        <i class="feather-heart"></i>
                      </a>
                    </div>
                  </div>
                  <div class="booking-det-info">
                    <h6 class="mb-3">
                      <router-link to="/booking/booking-details">Car Repair Services</router-link
                      ><span class="badge badge-soft-success ms-2">Completed</span>
                    </h6>
                    <ul class="booking-details">
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Booking Date</span>
                        <small class="me-2">: </small>23 Sep 2022, 10:00-11:00
                      </li>
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Amount</span>
                        <small class="me-2">: </small> $50.00<span
                          class="badge badge-soft-primary ms-2"
                          >COD</span
                        >
                      </li>
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Location</span>
                        <small class="me-2">: </small>Alabama, USA
                      </li>
                      <li class="d-flex align-items-center flex-wrap">
                        <span class="book-item">Provider</span>
                        <small class="me-2">: </small>
                        <div class="user-book d-flex align-items-center flex-wrap me-2">
                          <div class="avatar avatar-xs me-2">
                            <img
                              class="avatar-img rounded-circle"
                              alt="User Image"
                              src="@/assets/img/profiles/avatar-02.jpg"
                            />
                          </div>
                          John Smith
                        </div>
                        <p class="mb-0 me-2">
                          <i class="ti ti-point-filled fs-10 text-muted me-2"></i
                          >info@johnsmith.com
                        </p>
                        <p>
                          <i class="ti ti-point-filled fs-10 text-muted me-2"></i>+1
                          607-276-5393
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="text-end">
                  <div class="d-flex align-items-center flex-wrap row-gap-2">
                    <router-link to="/booking/booking" class="btn btn-dark me-2"
                      >Rebook</router-link
                    >
                    <router-link
                      to="/booking/booking"
                      class="btn btn-light"
                      data-bs-toggle="modal"
                      data-bs-target="#add-review"
                      ><i class="ti ti-circle-plus me-2"></i>Add Review</router-link
                    >
                  </div>
                  <div class="view-action mt-3 mb-0 me-0 ms-0">
                    <div class="rating">
                      <i class="fas fa-star filled me-1"></i>
                      <i class="fas fa-star filled me-1"></i>
                      <i class="fas fa-star filled me-1"></i>
                      <i class="fas fa-star filled me-1"></i>
                      <i class="fas fa-star filled me-1"></i>
                    </div>
                    <router-link to="/booking/booking-details" class="text-primary"
                      >View Details</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="card shadow-none booking-list">
              <div class="card-body d-md-flex align-items-center">
                <div
                  class="booking-widget d-sm-flex align-items-center row-gap-3 flex-fill mb-3 mb-md-0"
                >
                  <div class="booking-img me-sm-3 mb-3 mb-sm-0">
                    <router-link to="/booking/booking-details" class="avatar">
                      <img src="@/assets/img/services/service-10.jpg" alt="User Image" />
                    </router-link>
                    <div class="fav-item">
                      <a
                        href="javascript:void(0)"
                        class="fav-icon"
                        :class="{ selected: isClickedOne }"
                        @click="toggleClickedOne"
                      >
                        <i class="feather-heart"></i>
                      </a>
                    </div>
                  </div>
                  <div class="booking-det-info">
                    <h6 class="mb-3">
                      <router-link to="/booking/booking-details">Interior Designing</router-link
                      ><span class="badge badge-soft-info ms-2">Inprogress</span>
                    </h6>
                    <ul class="booking-details">
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Booking Date</span>
                        <small class="me-2">: </small>22 Sep 2022, 11:00-12:00
                      </li>
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Amount</span>
                        <small class="me-2">: </small> $50.00<span
                          class="badge badge-soft-primary ms-2"
                          >Paypal</span
                        >
                      </li>
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Location</span>
                        <small class="me-2">: </small>Washington, DC, USA
                      </li>
                      <li class="d-flex align-items-center flex-wrap">
                        <span class="book-item">Provider</span>
                        <small class="me-2">: </small>
                        <div class="user-book d-flex align-items-center flex-wrap me-2">
                          <div class="avatar avatar-xs me-2">
                            <img
                              class="avatar-img rounded-circle"
                              alt="User Image"
                              src="@/assets/img/profiles/avatar-02.jpg"
                            />
                          </div>
                          Quentin
                        </div>
                        <p class="mb-0 me-2">
                          <i class="ti ti-point-filled fs-10 text-muted me-2"></i
                          >info@quentin.com
                        </p>
                        <p>
                          <i class="ti ti-point-filled fs-10 text-muted me-2"></i>+1
                          601-810-9218
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="text-end">
                  <div class="d-flex align-items-center flex-wrap row-gap-2">
                    <router-link to="/customer/user-chat" class="btn btn-dark me-2"
                      ><i class="ti ti-message-2 me-2"></i>Chat</router-link
                    >
                    <router-link
                      to="/booking/booking"
                      class="btn btn-light"
                      data-bs-toggle="modal"
                      data-bs-target="#cancel_appointment"
                      >Cancel</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="card shadow-none booking-list">
              <div class="card-body d-md-flex align-items-center">
                <div
                  class="booking-widget d-sm-flex align-items-center row-gap-3 flex-fill mb-3 mb-md-0"
                >
                  <div class="booking-img me-sm-3 mb-3 mb-sm-0">
                    <router-link to="/booking/booking-details" class="avatar">
                      <img src="@/assets/img/services/service-11.jpg" alt="User Image" />
                    </router-link>
                    <div class="fav-item">
                      <a
                        href="javascript:void(0)"
                        class="fav-icon"
                        :class="{ selected: isClickedTwo }"
                        @click="toggleClickedTwo"
                      >
                        <i class="feather-heart"></i>
                      </a>
                    </div>
                  </div>
                  <div class="booking-det-info">
                    <h6 class="mb-3">
                      <router-link to="/booking/booking-details">Interior Designing</router-link
                      ><span class="badge badge-soft-info ms-2">Inprogress</span>
                    </h6>
                    <ul class="booking-details">
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Booking Date</span>
                        <small class="me-2">: </small>22 Sep 2022, 11:00-12:00
                      </li>
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Amount</span>
                        <small class="me-2">: </small> $50.00<span
                          class="badge badge-soft-primary ms-2"
                          >Paypal</span
                        >
                      </li>
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Location</span>
                        <small class="me-2">: </small>Washington, DC, USA
                      </li>
                      <li class="d-flex align-items-center flex-wrap">
                        <span class="book-item">Provider</span>
                        <small class="me-2">: </small>
                        <div class="user-book d-flex align-items-center flex-wrap me-2">
                          <div class="avatar avatar-xs me-2">
                            <img
                              class="avatar-img rounded-circle"
                              alt="User Image"
                              src="@/assets/img/profiles/avatar-02.jpg"
                            />
                          </div>
                          Quentin
                        </div>
                        <p class="mb-0 me-2">
                          <i class="ti ti-point-filled fs-10 text-muted me-2"></i
                          >info@quentin.com
                        </p>
                        <p>
                          <i class="ti ti-point-filled fs-10 text-muted me-2"></i>+1
                          601-810-9218
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="text-end">
                  <div class="d-flex align-items-center flex-wrap row-gap-2">
                    <router-link to="/customer/user-chat" class="btn btn-dark me-2"
                      ><i class="ti ti-message-2 me-2"></i>Chat</router-link
                    >
                    <router-link
                      to="/booking/booking"
                      class="btn btn-light"
                      data-bs-toggle="modal"
                      data-bs-target="#cancel_appointment"
                      >Cancel</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="card shadow-none booking-list mb-0">
              <div class="card-body d-md-flex align-items-center">
                <div
                  class="booking-widget d-sm-flex align-items-center row-gap-3 flex-fill mb-3 mb-md-0"
                >
                  <div class="booking-img me-sm-3 mb-3 mb-sm-0">
                    <router-link to="/booking/booking-details" class="avatar">
                      <img src="@/assets/img/services/service-12.jpg" alt="User Image" />
                    </router-link>
                    <div class="fav-item">
                      <a
                        href="javascript:void(0)"
                        class="fav-icon"
                        :class="{ selected: isClickedThree }"
                        @click="toggleClickedThree"
                      >
                        <i class="feather-heart"></i>
                      </a>
                    </div>
                  </div>
                  <div class="booking-det-info">
                    <h6 class="mb-3">
                      <router-link to="/booking/booking-details">Car Repair Services</router-link
                      ><span class="badge badge-soft-success ms-2">Completed</span>
                    </h6>
                    <ul class="booking-details">
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Booking Date</span>
                        <small class="me-2">: </small>23 Sep 2022, 10:00-11:00
                      </li>
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Amount</span>
                        <small class="me-2">: </small> $50.00<span
                          class="badge badge-soft-primary ms-2"
                          >COD</span
                        >
                      </li>
                      <li class="d-flex align-items-center mb-2">
                        <span class="book-item">Location</span>
                        <small class="me-2">: </small>Alabama, USA
                      </li>
                      <li class="d-flex align-items-center flex-wrap">
                        <span class="book-item">Provider</span>
                        <small class="me-2">: </small>
                        <div class="user-book d-flex align-items-center flex-wrap me-2">
                          <div class="avatar avatar-xs me-2">
                            <img
                              class="avatar-img rounded-circle"
                              alt="User Image"
                              src="@/assets/img/profiles/avatar-02.jpg"
                            />
                          </div>
                          John Smith
                        </div>
                        <p class="mb-0 me-2">
                          <i class="ti ti-point-filled fs-10 text-muted me-2"></i
                          >info@johnsmith.com
                        </p>
                        <p>
                          <i class="ti ti-point-filled fs-10 text-muted me-2"></i>+1
                          607-276-5393
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="text-end">
                  <div class="d-flex align-items-center flex-wrap row-gap-2">
                    <router-link to="/booking/booking" class="btn btn-dark me-2"
                      >Rebook</router-link
                    >
                    <router-link
                      to="/booking/booking"
                      class="btn btn-light"
                      data-bs-toggle="modal"
                      data-bs-target="#add-review"
                      ><i class="ti ti-circle-plus me-2"></i>Add Review</router-link
                    >
                  </div>
                  <div class="view-action mt-3 mb-0 me-0 ms-0">
                    <div class="rating">
                      <i class="fas fa-star filled me-1"></i>
                      <i class="fas fa-star filled me-1"></i>
                      <i class="fas fa-star filled me-1"></i>
                      <i class="fas fa-star filled me-1"></i>
                      <i class="fas fa-star filled me-1"></i>
                    </div>
                    <router-link to="/booking/booking-details" class="text-primary"
                      >View Details</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
  <user-booking-modal></user-booking-modal>
</template>
